import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useBreakpointsStore = defineStore('breakpointsStore', () => {
  const viewport = useViewport()

  const sizes = {
    ultrasmall: 0,
    xxs: 360,
    xs: 430,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    laptop: 1440,
    '2xl': 1920,
  }
  type Size = keyof typeof sizes

  // Текущий активный брейкпоинт (строка, например: 'md', 'laptop')
  const active = computed(() => viewport.breakpoint.value)

  const isMobile = computed(() => viewport.isLessThan('md'))

  const isUltrasmall = computed(() => viewport.isLessThan('xs'))

  const isSmallTablet = computed(() => viewport.match('md')) // 768 - 1023 px
  const isBigTablet = computed(() => viewport.match('lg')) // 1024 - 1279 px

  const isTablet = computed(() => isSmallTablet.value || isBigTablet.value) // 768 - 1279px

  const isLaptop = computed(() => viewport.match('xl')) // 1280 - 1439px
  const isBigLaptop = computed(() => viewport.match('laptop')) // 1440 - 1919px
  const isBigDesktop = computed(() => viewport.match('2xl')) // >= 1920px

  // Прокси-методы, сохраняющие вашу исходную сигнатуру
  const isMoreThan = (size: Size) => viewport.isGreaterThan(size)
  const isLessThan = (size: Size) => viewport.isLessThan(size)

  const isLessThanSm = computed(() => isLessThan('sm'))
  const isLessThanLg = computed(() => isLessThan('lg'))

  return {
    active,
    sizes,
    /**
     * < 430 px
     */
    isUltrasmall,
    /**
     * < 1024px
     */
    isMobile,
    /**
     * 768 - 1023 px
     */
    isSmallTablet,
    /**
     * 1024 - 1279 px
     */
    isBigTablet,
    /**
     * 768 - 1279px
     */
    isTablet,
    /**
     * 1280 - 1439px
     */
    isLaptop,
    /**
     * 1440 - 1919px
     */
    isBigLaptop,
    /**
     * >= 1920px
     */
    isBigDesktop,

    isMoreThan,
    isLessThan,

    isLessThanSm,
    isLessThanLg,
  }
})
